import {
  CommentDiscussionIcon,
  FileIcon,
  GitPullRequestIcon,
  IssueOpenedIcon,
  RepoIcon,
  StackIcon,
} from '@primer/octicons-react'

export const topLevelCategories = [
  {
    name: 'Extensions',
    icon: StackIcon,
    value: 'agents',
  },
  {
    name: 'Repositories',
    icon: RepoIcon,
    value: 'repositories',
  },
  {
    name: 'Files and folders',
    icon: FileIcon,
    value: 'repositories:files',
  },
  {
    name: 'Issues',
    icon: IssueOpenedIcon,
    value: 'repositories:issues',
  },
  {
    name: 'Pull requests',
    icon: GitPullRequestIcon,
    value: 'repositories:pulls',
  },
  {
    name: 'Discussions',
    icon: CommentDiscussionIcon,
    value: 'repositories:discussions',
  },
] as const

export type AutocompleteCategory = (typeof topLevelCategories)[number]

export type CategoryValue = AutocompleteCategory['value']
